// extracted by mini-css-extract-plugin
export default {"header__waffle-menu-title":"header__waffle-menu-title_Jy5onPyp"};